import { ROUTE_TEST_DETAILS } from '@/constants/routes';
import { setTitle } from '@/utils';
import { RouteObject } from 'react-router-dom';
import Page from './test-details.page';

export const routeTestDetails: RouteObject = {
  path: ROUTE_TEST_DETAILS,
  Component: Page,
  loader: ({ params }) => {
    setTitle(`Testing Recommendation - ${(params.idTest ?? '').replace('_', ' ')}`);
    return null;
  },
};
